import React from "react";
import { Box } from "@mui/material";

export default function HeroSection({
                                        images, // { mobilePortrait, tablet, desktop, monitor }
                                        children,
                                    }) {
    return (
        <Box
            sx={{
                width: "100%",
                // 100svh (small viewport height, i.e. with the address bar/toolbar
                // visible) instead of 100dvh: dvh recalculates continuously as
                // mobile browsers show/hide their toolbar while scrolling, and
                // since the background below uses object-fit: cover, every one of
                // those height changes rescales the image — visible as the hero
                // "zooming" during scroll. svh stays fixed, so the background never
                // resizes after the initial paint.
                height: "100svh",
                overflow: "hidden",
                position: "relative",
            }}
        >
            {/* Background Image */}
            <Box
                component="picture"
                sx={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                }}
            >
                {/* 1) Portrait phones */}
                <source
                    media="(orientation: portrait) and (max-width: 899px)"
                    srcSet={images.mobilePortrait}
                />

                {/* 2) Very large monitors */}
                <source media="(min-width: 2560px)" srcSet={images.monitor} />

                {/* 3) Desktops */}
                <source media="(min-width: 1200px)" srcSet={images.desktop} />

                {/* 4) Tablets / small laptops */}
                <source media="(min-width: 900px)" srcSet={images.tablet} />

                {/* Fallback (xs/sm landscape or anything else) */}
                <Box
                    component="img"
                    src={images.mobilePortrait}
                    alt="Hero background"
                    loading="eager"
                    fetchpriority="high"
                    sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                    }}
                />
            </Box>

            {/* Overlay Content */}
            {children && (
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 1,
                        width: "100%",
                        height: "100%",
                    }}
                >
                    {children}
                </Box>
            )}
        </Box>
    );
}
